import React, { useEffect, useState } from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { message, Collapse, Button } from 'antd';
import ItemContent from './ItemContent';
import Create from './Create';
import AdminWhatsapp from './AdminWhatsapp';

const Manage = () => {
  const [loading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = () => {
    setLoading(true);
    const url = `/faq/list`;
    axios.get(url).then(resp => {
      setFaqs(resp.data.faq);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data FAQ");
    });
  }

  const Content = () => {
    return (
      <Collapse accordion>
        {faqs.map((item, key) => {
          return(
            <Collapse.Panel header={item.title} key={item.id}>
              <ItemContent item={item} refreshList={fetchList}/>
            </Collapse.Panel>
          );
        })}
      </Collapse>
    )
  }

  return (
    <Auxiliary>
      <Title>Kelola FAQ</Title>
      <div className="gx-mb-2">
        <Create refreshList={fetchList} />
        <AdminWhatsapp />
      </div>
      <Content />
    </Auxiliary>
  );
}
export default Manage;